import { getService } from 'azure-devops-extension-sdk';
import { AP } from './jira';

interface NavigationService {
  init(): Promise<void>;
  replaceHash(hash: string): void;
  pushHash(hash: string): void;
  getHash(): Promise<string>;
  onHashChanged(callback: (hash: string) => void): void;
}

class JiraNavigationService implements NavigationService {
  onHashChangedCallback!: (hash: string) => void;

  init(): Promise<void> {
    AP.history.popState((event: any) => this.popStateCallback(event.newURL));
    return Promise.resolve();
  }

  replaceHash(hash: string): void {
    AP.history.replaceState(hash);
  }

  pushHash(hash: string): void {
    AP.history.pushState(hash);
  }

  getHash(): Promise<string> {
    return AP.history.getState('hash');
  }

  onHashChanged(callback: (hash: string) => void): void {
    this.onHashChangedCallback = callback;
  }

  popStateCallback(newURL: string): void {
    if (this.onHashChangedCallback) this.onHashChangedCallback(newURL);
  }
}

class AzureNavigationService implements NavigationService {
  azureHostNavigationService: any;
  onHashChangedCallback!: (hash: string) => void;

  async init(): Promise<void> {
    this.azureHostNavigationService = await getService(
      // TODO check how to fix this with TypeScript.
      // It won't work importing the enum due to the flag isolatedModules that is required with Babel.
      // CommonServiceIds.HostNavigationService
      'ms.vss-features.host-navigation-service'
    );
    this.azureHostNavigationService.onHashChanged((newUrl: string) =>
      this.onHashChangedAzureCallback(newUrl)
    );
  }

  replaceHash(hash: string): void {
    this.azureHostNavigationService.replaceHash(hash);
  }

  pushHash(hash: string): void {
    this.azureHostNavigationService.setHash(hash);
  }

  async getHash(): Promise<string> {
    const hash = await this.azureHostNavigationService.getHash();
    // Azure will return '#' as the initial character for the hash
    return hash ? hash.slice(1) : '';
  }

  onHashChanged(callback: (hash: string) => void): void {
    this.onHashChangedCallback = callback;
  }

  onHashChangedAzureCallback(newURL: string): void {
    // Azure will return '#' as the initial character for the hash
    if (this.onHashChangedCallback)
      this.onHashChangedCallback(newURL ? newURL.slice(1) : '');
  }
}

export { JiraNavigationService, AzureNavigationService };
